module.exports = __webpack_public_path__ + "static/media/audio-btn-hojablanco.8e35a8c0.svg";